"use client";

import React from "react";
import { useAmazonSignageStickBuyUrl } from "@/lib/hooks/useAmazonSignageStickBuyUrl";

type AmazonSignageStickBuyLinkProps = {
  children: React.ReactNode;
  className?: string;
  target?: string;
  rel?: string;
  "data-mixpanel-id"?: string;
};

export function AmazonSignageStickBuyLink({
  children,
  className,
  target = "_blank",
  rel,
  "data-mixpanel-id": mixpanelId,
}: AmazonSignageStickBuyLinkProps) {
  const { href } = useAmazonSignageStickBuyUrl();
  const resolvedRel =
    rel ?? (target === "_self" ? undefined : "noopener noreferrer");

  return (
    <a
      href={href}
      target={target}
      rel={resolvedRel}
      className={className}
      data-mixpanel-id={mixpanelId}
    >
      {children}
    </a>
  );
}
